import Vue from 'vue'

const preventReClick = Vue.directive('preventReClick', {
    inserted: function (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 4000)
            }
        })
    }
});

export { preventReClick }


// WEBPACK FOOTER //
// ./src/preventReClick.js